import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '@/components/admin/AdminLayout';
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage';
import FacilitiesPage from '@/pages/admin/FacilitiesPage';
import UsersPage from '@/pages/admin/UsersPage';
import BookingsPage from '@/pages/admin/BookingsPage';
import PaymentsPage from '@/pages/admin/PaymentsPage';
import AccountingPage from '@/pages/admin/AccountingPage';
import IntegrationsPage from '@/pages/admin/IntegrationsPage';
import ChatPage from '@/pages/admin/ChatPage';
import CampaignsPage from '@/pages/admin/CampaignsPage';
import ReviewsPage from '@/pages/admin/ReviewsPage';
import ReportsPage from '@/pages/admin/ReportsPage';
import BlogPage from '@/pages/admin/BlogPage';
import SettingsPage from '@/pages/admin/SettingsPage';
import SmsTemplatesPage from '@/pages/admin/SmsTemplatesPage';

const AdminDashboard = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<AdminDashboardPage />} />
        <Route path="facilities" element={<FacilitiesPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="accounting" element={<AccountingPage />} />
        <Route path="integrations" element={<IntegrationsPage />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="campaigns" element={<CampaignsPage />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="sms-templates" element={<SmsTemplatesPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminDashboard;
